import request from '@/utils/request'

const api = {
  create: '/api/retail/transfer/create',
  approve: '/api/retail/transfer/approve',
  outStock: '/api/retail/transfer/outStock',
  inStock: '/api/retail/transfer/inStock',
  cancel: '/api/retail/transfer/cancel',
  detail: '/api/retail/transfer/detail',
  list: '/api/retail/transfer/list'
}

export default api

export function createTransferOrder(parameter) {
  return request({
    url: api.create,
    method: 'post',
    data: parameter
  })
}

export function approveTransferOrder(parameter) {
  return request({
    url: api.approve,
    method: 'post',
    params: parameter
  })
}

export function outStockTransferOrder(parameter) {
  return request({
    url: api.outStock,
    method: 'post',
    params: parameter
  })
}

export function inStockTransferOrder(parameter) {
  return request({
    url: api.inStock,
    method: 'post',
    data: parameter
  })
}

export function cancelTransferOrder(parameter) {
  return request({
    url: api.cancel,
    method: 'post',
    params: parameter
  })
}

export function getTransferOrderDetail(parameter) {
  return request({
    url: api.detail,
    method: 'get',
    params: parameter
  })
}

export function getTransferOrderList(parameter) {
  return request({
    url: api.list,
    method: 'get',
    params: parameter
  })
}
